import type {ExpressionExportProps, ExpressionV4} from '../types';

export const getExpressionExportProps = (
  expression: ExpressionV4,
  // To avoid nullish expressionFormat if previous value, e.g. when editing on autocomplete field
  previous?: ExpressionExportProps,
): ExpressionExportProps => {
  return {
    expressionFormat:
      expression?.expressionFormat ?? previous?.expressionFormat,
  };
};
